module.exports = __webpack_public_path__ + "static/img/4.e04b294.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/menthu/2/4.png
// module id = XO+x
// module chunks = 0